import { HbrBulletinIcon } from "../MyCustomsvgicons";

const ViewersList = ({userName, unitloc, userid, ishost}) => {

    return (
        <div className="viewers-list flex-row2" style={{gap: "2em", borderBottom:"1px solid grey", flexWrap:"wrap"}}>
                <HbrBulletinIcon width={"1.7em"} height={"1.7em"} fillColour={"green"}/>
                <h4>{userName}</h4>
                <h5>Loc: {unitloc}</h5>
                {ishost && <h5>Contact: {userid}</h5>}
        </div>
      );
}
export default ViewersList;